import React from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from '../ui/card';
import {Input} from '../ui/input';
import {Label} from '../ui/label';
import {User} from 'lucide-react';

const PersonalInformationSection = ({formData, setFormData}) => {
  return (
    <Card className="glass-effect border-gray-700">
      <CardHeader>
        <CardTitle className="text-white flex items-center">
          <User className="h-5 w-5 mr-2 text-blue-400" />
          Personal Information
        </CardTitle>
        <CardDescription className="text-gray-300">
          Emergency contact and basic information
        </CardDescription>
      </CardHeader>
      <CardContent className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="emergencyContact" className="text-white">
            Emergency Contact Name
          </Label>
          <Input
            id="emergencyContact"
            value={formData.emergencyContact}
            onChange={e =>
              setFormData ({...formData, emergencyContact: e.target.value})}
            className="bg-gray-800 border-gray-600 text-white"
            placeholder="Full name of emergency contact"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="emergencyPhone" className="text-white">
            Emergency Contact Phone
          </Label>
          <Input
            id="emergencyPhone"
            value={formData.emergencyPhone}
            onChange={e =>
              setFormData ({...formData, emergencyPhone: e.target.value})}
            className="bg-gray-800 border-gray-600 text-white"
            placeholder="Phone number"
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default PersonalInformationSection;
